import { useEffect } from "react"
import particlesConfig from "../particlesConfig.json"
import "./styles.scss"

export default function Redirect() {
  useEffect(() => {
    window.particlesJS("particles-js", particlesConfig)
  }, [])

  return <div className="redirect-wrapper">
    <div id="particles-js" />
    <div className="redirect-page">
      <div className="content">
        <div className="title">Redirecting</div>
        <div className="subtitle">Please wait while you&apos;re redirected. You can safely close this window.</div>
      </div>
    </div>
  </div>
}
